"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDealer = exports.updateCredits = exports.searchDealersForAdmin = exports.searchDealers = exports.getDealers = exports.getDealerIds = exports.getDealerHoldInfo = exports.getDealerCities = exports.getDealerById = exports.getAvailableDealers = exports.getAgentRoleWiseDealer = exports.getAgentDealers = exports.generateNewDealerCode = exports.downloadExcel = exports.deleteDealer = exports.defaultDealerData = exports.dealersCount = exports.createDealer = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultDealerData = exports.defaultDealerData = {
  id: 0,
  enabled: true,
  isUnit: false,
  tcsApplicable: false,
  isMonthlyCashDiscountApplicable: true,
  isCollectible: true,
  name: '',
  tallyAlias: '',
  code: '',
  status: 'Pending',
  logo: undefined,
  holdBy: null,
  holdReason: null,
  agentId: null,
  agent: {
    id: 0
  },
  dealersRoleId: null,
  dealersRole: {
    id: 0
  },
  branchId: null,
  stockBranchId: null,
  branch: {
    id: 0
  },
  scheme: [],
  specialDiscount: 0,
  hasSeparateAddress: false,
  appDiscount: null,
  excludeFromMobileSchemes: false,
  branchForBillReversal: null
};
const getDealers = params => (0, _request.default)({
  url: '/dealers',
  method: 'get',
  params
});
exports.getDealers = getDealers;
const getDealerById = id => (0, _request.default)({
  url: `/dealers/${id}`,
  method: 'get'
});
exports.getDealerById = getDealerById;
const updateDealer = (id, data) => (0, _request.default)({
  url: `/dealers/${id}`,
  method: 'patch',
  data
});
exports.updateDealer = updateDealer;
const deleteDealer = id => (0, _request.default)({
  url: `/dealers/${id}`,
  method: 'delete'
});
exports.deleteDealer = deleteDealer;
const createDealer = data => (0, _request.default)({
  url: '/dealers',
  method: 'post',
  data
});
exports.createDealer = createDealer;
const getDealerCities = data => (0, _request.default)({
  url: '/dealers/dealerCities',
  method: 'post',
  data
});
exports.getDealerCities = getDealerCities;
const getDealerIds = data => (0, _request.default)({
  url: '/dealers/dealerIds',
  method: 'post',
  data
});
exports.getDealerIds = getDealerIds;
const getAgentDealers = data => (0, _request.default)({
  url: '/dealers/agent-dealers',
  method: 'post',
  data
});
exports.getAgentDealers = getAgentDealers;
const getAgentRoleWiseDealer = params => (0, _request.default)({
  url: '/dealers/agent-role-wise-dealers',
  method: 'get',
  params
});
exports.getAgentRoleWiseDealer = getAgentRoleWiseDealer;
const downloadExcel = data => (0, _request.default)({
  url: '/dealers/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
exports.downloadExcel = downloadExcel;
const dealersCount = params => (0, _request.default)({
  url: '/dealers/count',
  method: 'get',
  params
});
exports.dealersCount = dealersCount;
const searchDealers = params => (0, _request.default)({
  url: '/dealers/search',
  method: 'get',
  params
});
exports.searchDealers = searchDealers;
const getDealerHoldInfo = id => (0, _request.default)({
  url: `/dealers/hold-info/${id}`,
  method: 'get'
});
exports.getDealerHoldInfo = getDealerHoldInfo;
const updateCredits = () => {
  return (0, _request.default)({
    url: '/dealers/update-credits',
    method: 'get'
  });
};
exports.updateCredits = updateCredits;
const getAvailableDealers = params => (0, _request.default)({
  url: '/dealers/available-dealers',
  method: 'get',
  params
});
exports.getAvailableDealers = getAvailableDealers;
const searchDealersForAdmin = params => (0, _request.default)({
  url: '/dealers/search-dealers',
  method: 'get',
  params
});
exports.searchDealersForAdmin = searchDealersForAdmin;
const generateNewDealerCode = data => (0, _request.default)({
  url: '/dealers/generate-dealer-code',
  method: 'post',
  data
});
exports.generateNewDealerCode = generateNewDealerCode;